import {
    DocumentoCasoContaController,
    DocumentoCasoContaVistoriaController,
    GetAssinaturasCasoDocumentoController,
} from "../../Controllers/Geral/Documentos/DocumentosController";
import { IDocumentoCasoConta } from "../../Interfaces/Geral/Documentos/DocumentosInterface";
import useAsyncEffect from "../../hooks/useAsyncEffect";
import OrSpinner from "../Utils/OrSpinner";
import { ETAPA_ENTREGA_CHAVES } from "../../Constants/EntregaChaves";

interface IVisualizarAssinaturasProps {
    idCaso: number;
    cdEtapa?: string;
}

export default function VisualizarAssinaturas(
    props: IVisualizarAssinaturasProps
) {
    const { value: assinaturaCliente, loading: assinaturaClienteLoading } =
        useAsyncEffect(async () => {
            return DocumentoCasoContaController(
                0,
                `Assinatura_Entrega_Chaves_Cliente_${props.idCaso}_${props.cdEtapa}.png`,
                props.idCaso
            );
        }, []);

    const { value: assinaturaTecnico, loading: assinaturaTecnicoLoading } =
        useAsyncEffect(async () => {
            return DocumentoCasoContaController(
                0,
                `Assinatura_Entrega_Chaves_Tecnico_${props.idCaso}_${props.cdEtapa}.png`,
                props.idCaso
            );
        }, []);
    const { value: termoEntrega, loading: termoEntregaLoading } =
        useAsyncEffect(async () => {
            return DocumentoCasoContaController(
                0,
                `Assinatura_Entrega_TermoEntrega_${props.idCaso}.png`,
                props.idCaso
            );
        }, []);
    const { value: termoEntregaTecnico, loading: termoEntregaTecnicoLoading } =
        useAsyncEffect(async () => {
            return DocumentoCasoContaController(
                0,
                `Assinatura_Entrega_TermoEntrega_Tecnico_${props.idCaso}.png`,
                props.idCaso
            );
        }, []);
    const { value: documentosForm, loading: documentoClienteLoading } =
        useAsyncEffect(async () => {
            return DocumentoCasoContaVistoriaController(props.idCaso);
        }, []);

    const {
        value: getAssinaturaCasoDocumento,
        loading: getAssinaturaCasoDocumentoLoading,
    } = useAsyncEffect(async () => {
        return GetAssinaturasCasoDocumentoController(props.idCaso);
    }, []);

    const imagemInicial =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC";

    function assinaturaClienteSrc() {
        const assinaturaDrive = assinaturaCliente?.DS_LINK_DRIVE
            ? assinaturaCliente.DS_LINK_DRIVE
            : "";

        const splited = assinaturaDrive?.split("/");

        const driveFileId = splited ? splited[splited.length - 2] : "00";

        if (assinaturaCliente?.IM_DOCUMENTO) {
            return `data:image/png;base64,${assinaturaCliente.IM_DOCUMENTO}`;
        } else if (assinaturaCliente?.DS_LINK_DRIVE) {
            return `https://docs.google.com/uc?id=${driveFileId}`;
        }
    }

    function assinaturaTecnicoSrc() {
        const assinaturaDrive = assinaturaTecnico?.DS_LINK_DRIVE
            ? assinaturaTecnico.DS_LINK_DRIVE
            : "";

        const splited = assinaturaDrive?.split("/");

        const driveFileId = splited ? splited[splited.length - 2] : "00";

        if (assinaturaTecnico?.IM_DOCUMENTO) {
            return `data:image/png;base64,${assinaturaTecnico.IM_DOCUMENTO}`;
        } else if (assinaturaTecnico?.DS_LINK_DRIVE) {
            return `https://docs.google.com/uc?id=${driveFileId}`;
        }
    }

    function formatAssinaturaSrc(assinatura: IDocumentoCasoConta | undefined) {
        const assinaturaDrive = assinatura?.DS_LINK_DRIVE
            ? assinatura.DS_LINK_DRIVE
            : "";

        const splited = assinaturaDrive?.split("/");

        const driveFileId = splited ? splited[splited.length - 2] : "00";

        if (assinatura?.IM_DOCUMENTO) {
            return `data:image/png;base64,${assinatura.IM_DOCUMENTO}`;
        } else if (assinatura?.DS_LINK_DRIVE) {
            return `https://drive.google.com/thumbnail?id=${driveFileId}`;
        }
    }

    function pegarIdImagemDrive(
        retorno: Array<{
            IM_DOCUMENTO: string | null;
            DS_LINK_DRIVE: string;
            NR_TAMANHO: number;
        }>
    ) {
        for (const obj of retorno) {
            const assinaturaDrive = obj.DS_LINK_DRIVE ? obj.DS_LINK_DRIVE : "";
            const splited = assinaturaDrive.split("/");
            const driveFileId = splited ? splited[splited.length - 2] : "00";

            if (driveFileId !== "00") {
                return driveFileId;
            }
        }

        return null;
    }

    function DocumentosSrc() {
        if (Array.isArray(documentosForm)) {
            return documentosForm
                .map((cliente) => {
                    if (cliente.DS_LINK_DRIVE) {
                        // Se DS_LINK_DRIVE estiver presente, use-o
                        return `https://drive.google.com/thumbnail?id=${pegarIdImagemDrive(
                            [cliente]
                        )}`;
                    } else if (cliente.IM_DOCUMENTO) {
                        // Caso contrário, use IM_DOCUMENTO como base64
                        return `data:image/png;base64,${cliente.IM_DOCUMENTO}`;
                    }
                    return null;
                })
                .filter((link) => link !== null);
        }
        return [];
    }

    return (
        <OrSpinner
            loading={
                assinaturaTecnicoLoading ||
                assinaturaClienteLoading ||
                termoEntregaLoading ||
                termoEntregaTecnicoLoading ||
                documentoClienteLoading ||
                getAssinaturaCasoDocumentoLoading
            }
            spinner="capys"
        >
            <div className="d-flex flex-column align-items-center justify-content-center">
                {(assinaturaCliente?.IM_DOCUMENTO ||
                    assinaturaCliente?.DS_LINK_DRIVE) && (
                    <>
                        <h5>Assinatura Cliente </h5>
                        <div className="border border-secondary">
                            <img
                                className={"sigImage"}
                                src={
                                    assinaturaClienteSrc()
                                        ? assinaturaClienteSrc()
                                        : imagemInicial
                                }
                                alt="Assinatura do usúario"
                                style={{
                                    height: 150,
                                    width: 400,
                                    resize: "initial",
                                }}
                            />
                        </div>
                    </>
                )}

                {(assinaturaTecnico?.DS_LINK_DRIVE ||
                    assinaturaTecnico?.IM_DOCUMENTO) && (
                    <>
                        <h5>Assinatura Técnico </h5>
                        <div className="border border-secondary">
                            <img
                                className={"sigImage"}
                                src={
                                    assinaturaTecnicoSrc()
                                        ? assinaturaTecnicoSrc()
                                        : imagemInicial
                                }
                                alt="Assinatura do usúario em branco"
                                style={{
                                    height: 150,
                                    width: 400,
                                    resize: "initial",
                                }}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className="d-flex flex-column align-items-center justify-content-center py-2">
                {props.cdEtapa ===
                ETAPA_ENTREGA_CHAVES.RESPONDER_OBRA_CONCLUIDA_ACEITE_UNIDADE
                    .CD_ETAPA ? (
                    <>
                        <h5>Imagens</h5>
                        <div className="py-2">
                            <img
                                className="sigImage"
                                src={formatAssinaturaSrc(termoEntrega) ?? ""}
                                alt="Imagens dos documentos"
                                style={{
                                    height: 150,
                                    width: 400,
                                    resize: "initial",
                                }}
                            />
                        </div>
                        <div className="py-2">
                            <img
                                className="sigImage"
                                src={
                                    formatAssinaturaSrc(termoEntregaTecnico) ??
                                    ""
                                }
                                alt="Imagens dos documentos"
                                style={{
                                    height: 150,
                                    width: 400,
                                    resize: "initial",
                                }}
                            />
                        </div>
                    </>
                ) : props.cdEtapa ===
                      ETAPA_ENTREGA_CHAVES.RESPONDER_FORMULARIO_CONFORME
                          .CD_ETAPA ||
                  props.cdEtapa ===
                      ETAPA_ENTREGA_CHAVES.REALIZAR_VISTORIA.CD_ETAPA ? (
                    <>
                        <h5>Imagens</h5>
                        {getAssinaturaCasoDocumento?.ENTREGA_CHAVES.map(
                            (link, index) => {
                                const assinaturaDrive = link?.DS_LINK_DRIVE
                                    ? link.DS_LINK_DRIVE
                                    : "";

                                const splited = assinaturaDrive?.split("/");

                                const driveFileId = splited
                                    ? splited[splited.length - 2]
                                    : "00";

                                return (
                                    <div className="py-2" key={index}>
                                        <img
                                            className="sigImage"
                                            src={
                                                link.IM_DOCUMENTO
                                                    ? `data:image/png;base64,${link.IM_DOCUMENTO}`
                                                    : `https://drive.google.com/thumbnail?id=${driveFileId}`
                                            }
                                            alt="Imagens dos documentos"
                                            style={{
                                                height: 150,
                                                width: 400,
                                                resize: "initial",
                                            }}
                                        />
                                    </div>
                                );
                            }
                        )}
                    </>
                ) : props.cdEtapa ===
                  ETAPA_ENTREGA_CHAVES.RESPONDER_PESQUISA_ENTREGA_CHAVES
                      .CD_ETAPA ? (
                    <></>
                ) : (
                    <>
                        <h5>Imagens</h5>
                        {DocumentosSrc().map((link, index) => (
                            <div className="py-2" key={index}>
                                <img
                                    className="sigImage"
                                    src={link ?? ""}
                                    alt="Imagens dos documentos"
                                    style={{
                                        height: 150,
                                        width: 400,
                                        resize: "initial",
                                    }}
                                />
                            </div>
                        ))}
                    </>
                )}
            </div>
        </OrSpinner>
    );
}
